import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import styles from './FilterButtons.scss';
import { ActivityFilters } from '../filters';
import { useTranslation } from 'react-i18next';

export interface FilterButtonsProps {
  activityTypes: string[];
  activityFilter: string;
  setActivityFilter: React.Dispatch<React.SetStateAction<string>>;
}

export const FilterButtons: FunctionComponent<FilterButtonsProps> = props => {
  const { t } = useTranslation('common', { useSuspense: false });
  return (
    <>
      {props.activityTypes.map(a => {
        return (
          <button
            key={a}
            type="button"
            onClick={() => props.setActivityFilter(a)}
            className={classNames(
              styles.button,
              'jg-text--small-regular',
              props.activityFilter === a ? styles.active : '',
            )}
            disabled={props.activityFilter === a}
          >
            {t(ActivityFilters[a].label)}
          </button>
        );
      })}
    </>
  );
};
